import { Settings } from "@templates/index"

import InventoryNotificationsForm from "@pages/Settings/SettingsNotifications/components/InventoryNotificationsForm/InventoryNotificationsForm"

import { SETTINGS_ROUTES } from "@routes/settings"

export default function SettingsNotificationsInventory() {
    return (
        <Settings.Wrapper title="Inventory" backDestination={SETTINGS_ROUTES.notifications} alwaysShowHeader={true}>
            <Settings.PageContainer>
                <Settings.PageHeader
                    variant="page-heading"
                    title="Inventory"
                    subtitle="Select the topics for which you'd like to receive notifications."
                />

                <Settings.Divider />
                <InventoryNotificationsForm />
            </Settings.PageContainer>
        </Settings.Wrapper>
    )
}
